import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function SubscribeCancelPage() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050B1F] text-white font-geist px-6 relative">
      <div className="absolute inset-0 auth-grid pointer-events-none opacity-40" />
      <div className="relative max-w-md w-full text-center" data-testid="subscribe-cancel-page">
        <div className="h-14 w-14 rounded-full bg-red-500/10 border border-red-400/30 flex items-center justify-center mx-auto mb-6">
          <XCircle className="h-7 w-7 text-red-300" strokeWidth={2} />
        </div>
        <div className="font-geist-mono text-[10px] uppercase tracking-widest text-white/40 mb-3">
          Pagamento annullato
        </div>
        <h1 className="font-geist text-2xl md:text-3xl font-semibold text-white leading-tight">
          Nessun addebito effettuato
        </h1>
        <p className="mt-3 font-geist-mono text-[11px] text-white/50 leading-relaxed">
          Puoi riprovare in qualsiasi momento. La prova gratuita di 7 giorni è ancora disponibile.
        </p>
        <Button
          data-testid="subscribe-cancel-retry"
          onClick={() => nav("/subscribe")}
          className="mt-8 h-11 px-6 rounded-sm bg-[#4D8AFF] hover:bg-[#75A6FF] text-[#050B1F] font-geist font-semibold"
        >
          Riprova →
        </Button>
      </div>
    </div>
  );
}
